// Me home (A5P13), owned by hand: the organizations and, while an account deletion is pending, the cancel.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { MeHome } from '../../features/account/MeHome'
import { meQuery } from '../../shared/org/me'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/me/')({
  staticData: { screenId: 'MeHomeScreen', access: 'signed in', ownHeader: true },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: MeHomeScreen,
})

function MeHomeScreen() {
  return (
    <Part testId={ids.meHome.skeleton}>
      <MeHome />
    </Part>
  )
}
